module.exports = __webpack_public_path__ + "media/images/joinus-fddd48aae02d811a166f58380948e7b9.png";